import React from 'react'
import { IList } from './List.types'
import IconBullet from './components/IconBullet'

// MUI
import ListComponent from '@mui/material/List'
import { Theme } from '@mui/material/styles'

const styles = {
  root: ({ breakpoints }: Theme) => ({
    '& li': {
      '&:last-child': {
        paddingBottom: 0,
      },
      [breakpoints.down('sm')]: {
        padding: `0 0 16px 0`,
      },
    },
  }),
}

const List = ({ id, listItems }: IList) => {
  return (
    <ListComponent sx={styles.root} id={id}>
      {listItems.map((listItem, index) => (
        <IconBullet key={index} {...listItem} />
      ))}
    </ListComponent>
  )
}

export default List
